
// src/web/components/diary-forms-kpi-item.jsx

import React from 'react'
import { translate } from 'react-i18next'
import { themr } from 'react-css-themr'
import {
  IconButton,
} from 'react-toolbox/lib/button'
import diaryKpiTheme from './themes/diary-kpi.css'
import classnames from 'classnames'
import { formatNumber, percent } from '../../helpers/format-number'
import Input from 'react-toolbox/lib/input'
import compactInputTheme from './themes/compact-input.css'
import Tooltip from 'react-toolbox/lib/tooltip'

const TooltipIconButton = Tooltip(IconButton)

function Row(props) {
  const {
    t,
    theme,
    label,
    value,
    error,
    isPercent,
    onChange,
    format,
    unit,
  } = props

  var step = 1
  if (format && format.decimal_1)
    step = 0.1
  else if (format && format.decimal_2)
    step = 0.01
  else if (format && format.decimal_3)
    step = 0.001

  return (
    <div className={theme.row}>
      <div className={theme.label}>{label}</div>
      {!onChange &&
      <div className={theme.value}>
        {!onChange && !isPercent &&
          <span>
            {format.prepend_unit && <span className={theme.unit}>{unit}</span>}
            <span className={theme.number}>
              {formatNumber(value, format)}
            </span>
            {!format.prepend_unit && <span className={theme.unit}>{unit}</span>}
          </span>}
        {!onChange && isPercent && value >= 1.0 && isFinite(value) &&
          <span className={theme.achieved}>{t('label:達成')}</span>}
        {!onChange && isPercent && 
          <span>
            <span className={theme.number}>{percent(value)}</span>
            <span className={theme.unit}>%</span>
          </span>}
        </div>}
      {onChange &&
        <input type="number"
          step={step}
          autoComplete={false}
          onChange={onChange}
          placeholder={error && t('label:値を入力してください')}
          className={classnames(theme.input, error && theme.error)}
          value={value || ''} />
      }
      {onChange && <div className={theme.unit}>{unit}</div>}
    </div>
  )
}

@themr('DiaryFormsKPIItem', diaryKpiTheme)
class DiaryFormsKPIItem extends React.Component {
  render() {
    const {
      t,
      theme,
      kpi,
      onChange,
      value,
      total_value,
      error,
      total_error,
      showKpi,
    } = this.props

    var opt_value = typeof kpi.total == 'undefined' ? value : total_value

    return (
      <div className={theme.kpi} >
        <h3 className={classnames(theme.title, theme.clickable)} onClick={showKpi} >
          {kpi.name}
          <TooltipIconButton icon='arrow_forward' tooltip={t('label:グラフを表示')} />
        </h3>
        <div className={theme.rows}>
          <Row t={t} theme={theme} label={t('label:目標')} value={kpi.target} format={kpi.display_format} unit={kpi.unit} />
          <Row t={t} theme={theme} label={t('label:実績')} value={value} format={kpi.display_format} unit={kpi.unit} onChange={(ev) => onChange(ev, kpi, 'actual')} error={error} />
          { typeof kpi.total != 'undefined' &&
            <Row t={t} theme={theme} label={t('label:累計')} value={total_value} format={kpi.display_format} unit={kpi.unit} onChange={(ev) => onChange(ev, kpi, 'total')} error={total_error} />}
          <Row t={t} theme={theme} label={t('label:達成率')} value={opt_value / kpi.target} isPercent />
        </div>
      </div>
    )
  }
}

export default translate()(DiaryFormsKPIItem)



// WEBPACK FOOTER //
// ./src/web/components/diary-forms-kpi-item.jsx